<template>
  <v-select
    :value="value"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :items="serialNumberRequirementOverrideTypes"
    item-value="name"
    item-text="description"
    clearable
    return-object
  >
    <template v-slot:item="data">
      <v-list-item-content>{{ data.item.description }}</v-list-item-content>
    </template>
    <template v-slot:selection="data">
      {{ data.item.description }}
    </template>
  </v-select>
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "SerialNumberRequirementOverrideTypeField",
  props: {
    value: [Object, String]
  },
  data: () => ({
    serialNumberRequirementOverrideTypes: []
  }),
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    }
  },
  mounted() {
    ApiService.get("/api/types/serialNumberRequirementOverrides").then(({ data }) => {
      this.serialNumberRequirementOverrideTypes = data;
    });
  }
};
</script>
